import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { Cliente } from '../../models/clientes/cliente';
import { ClienteArquivo } from '../../models/clientes/cliente-arquivo';
import { ClienteFiltrar } from '../../models/clientes/cliente-filtrar';
import { ClienteLocalEntrega } from '../../models/clientes/cliente-local-entrega';
import { ClienteTabela } from '../../models/clientes/cliente-tabela';
import { ClienteVinculado } from '../../models/clientes/cliente-vinculado';

@Injectable({
  providedIn: 'root'
})

export class ClienteService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  public add(cliente: Cliente): Observable<number> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "cliente": cliente
    };

    return this.http.post<number>(this.baseUrl + "api/Cliente/Add", data, { headers: this.headers }).pipe(
      catchError((err) => {
        if (err.status === 400 && err.error && err.error.erros) {
          this.toastr.error(err.error.erros.join(', '), 'Campos obrigatórios (Efetivo):');
        } else if (err.status === 400 && err.error && err.error.message) {
          this.toastr.error("", err.error.message);
        } else {
          this.toastr.error("", "Houve um erro, contate o suporte...");
        }
        return of(0);
      })
    );
  }

  public addMultiplos(clientes: Cliente[]): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "clientes": clientes
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/AddMultiplos", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public importarLeads(linhas: any[]): Observable<any> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis"),
      "linhas": linhas
    };

    return this.http.post<any>(this.baseUrl + "api/Cliente/ImportarLeads", data, { headers: this.headers }).pipe(
      catchError((err) => {
        const mensagem = err && err.error && err.error.message ? err.error.message : "Houve um erro ao importar os leads.";
        this.toastr.error("", mensagem);

        return of(null);
      })
    );
  }

  public getByClientDocument(client_document: string): Observable<Cliente> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_document": client_document,
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<Cliente>(this.baseUrl + "api/Cliente/GetByClientDocument", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(null);
      })
    );
  }

  public getByCodigoERPCliente(codigo_no_erp_do_cliente: string): Observable<Cliente> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "codigo_no_erp_do_cliente": codigo_no_erp_do_cliente,
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<Cliente>(this.baseUrl + "api/Cliente/GetByCodigoERPCliente", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(null);
      })
    );
  }

  public getByGuidClienteNapis(filtrar?: ClienteFiltrar): Observable<Cliente[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis"),
      "filtrar": filtrar
    };

    return this.http.post<Cliente[]>(this.baseUrl + "api/Cliente/GetByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public getById(client_id_app: number): Observable<Cliente> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app
    };

    return this.http.post<Cliente>(this.baseUrl + "api/Cliente/GetById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(null);
      })
    );
  }

  public atualizarClienteSapServiceLayer(client_id_app: number): Observable<any> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app,
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<any>(this.baseUrl + "api/Cliente/AtualizarClienteSapServiceLayer", data, { headers: this.headers }).pipe(
      catchError((err) => {
        let mensagem = "Houve um erro ao atualizar o cliente TR.";

        if (err.error != null) {
          if (err.error.erros != null && err.error.erros.length > 0) {
            mensagem = err.error.erros.join(" | ");
          } else if (err.error.mensagem != null) {
            mensagem = err.error.mensagem;
          } else if (err.error.message != null) {
            mensagem = err.error.message;
          }
        }

        this.toastr.error("", mensagem);

        return of(null);
      })
    );
  }

  public getByTelefone(telefone: string): Observable<Cliente> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "telefone": telefone,
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<Cliente>(this.baseUrl + "api/Cliente/GetByTelefone", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(null);
      })
    );
  }

  public getStatusIntegracaoCliente(client_id: number): Observable<{ id: number; status: string; data: Date }[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id": client_id
    };

    return this.http.post<{ id: number; status: string; data: Date }[]>(this.baseUrl + "api/Cliente/GetStatusIntegracaoCliente", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public getByUsuario(inativos: boolean, filtrar?: ClienteFiltrar): Observable<Cliente[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": localStorage.getItem("id"),
      "inativos": inativos,
      "filtrar": filtrar
    };

    return this.http.post<Cliente[]>(this.baseUrl + "api/Cliente/GetByUsuario", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public getSubsegmentos(guidclientenapis: string): Observable<{ id: number; nome_subsegmento: string; guidclientenapis: string }[]> {
    this.headers.set("Content-Type", "application/json");

    let data = { "guidclientenapis": guidclientenapis };

    return this.http.post<any[]>(this.baseUrl + "api/Cliente/GetSubsegmentos", data, { headers: this.headers }).pipe(
      catchError(() => of([]))
    );
  }

  public getFiltroOpcoes(): Observable<{ segmentos: string[]; ramosAtividade: string[]; gruposRegiao: string[]; subsegmentos: string[]; subsegmentos2: string[]; redePostos: string[]; cidades: string[]; classificacoes: string[] }> {
    this.headers.set("Content-Type", "application/json");

    let data = { "guidclientenapis": localStorage.getItem("guidclientenapis") };

    return this.http.post<any>(this.baseUrl + "api/Cliente/GetFiltroOpcoes", data, { headers: this.headers }).pipe(
      catchError(() => of({ segmentos: [], ramosAtividade: [], gruposRegiao: [], subsegmentos: [], subsegmentos2: [], redePostos: [], cidades: [], classificacoes: [] }))
    );
  }

  public getContagemTipos(): Observable<{ cadastrados: number; efetivadosACadastrar: number; leads: number }> {
    this.headers.set("Content-Type", "application/json");

    let data = { "guidclientenapis": localStorage.getItem("guidclientenapis") };

    return this.http.post<{ cadastrados: number; efetivadosACadastrar: number; leads: number }>(this.baseUrl + "api/Cliente/GetContagemTipos", data, { headers: this.headers }).pipe(
      catchError(() => of({ cadastrados: 0, efetivadosACadastrar: 0, leads: 0 }))
    );
  }

  public getClienteFiltrosConfigurados(): Observable<{ filtros: { campo: string; label: string; tipo: string; opcoes: string[]; ordem: number }[]; buscaGeral: { campo: string; label: string } }> {
    this.headers.set("Content-Type", "application/json");

    let data = { "guidclientenapis": localStorage.getItem("guidclientenapis") };

    return this.http.post<any>(this.baseUrl + "api/Cliente/GetClienteFiltrosConfigurados", data, { headers: this.headers }).pipe(
      catchError(() => of({ filtros: [], buscaGeral: { campo: 'DESCRICAO', label: 'Buscar' } }))
    );
  }

  public searchPaged(filtros: { tipo: string; valor: string }[], page: number = 0, pageSize: number = 0): Observable<{ items: Cliente[]; total: number; page: number; pageSize: number }> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id_usuario": localStorage.getItem("id"),
      "filtros": filtros,
      "page": page,
      "pageSize": pageSize
    };

    return this.http.post<{ items: Cliente[]; total: number; page: number; pageSize: number }>(this.baseUrl + "api/Cliente/SearchPaged", data, { headers: this.headers }).pipe(
      catchError((error: any) => {
        const msg: string | undefined = error && error.error && error.error.message;
        if (msg) {
          this.toastr.warning(msg, "Aviso");
        } else {
          this.toastr.error("", "Houve um erro, contate o suporte...");
        }
        return of({ items: [], total: 0, page: 0, pageSize });
      })
    );
  }

  public exportarExcel(filtros: { tipo: string; valor: string }[], aba: string): Observable<Blob> {
    let data = {
      "id_usuario": localStorage.getItem("id"),
      "filtros": filtros,
      "aba": aba
    };

    return this.http.post(this.baseUrl + "api/Cliente/ExportarExcel", data, { responseType: 'blob' as 'json' }) as Observable<Blob>;
  }

  public sendEmailCadastro(client_id_app: number, email: string): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app,
      "email": email
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/SendEmailCadastro", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public update(cliente: Cliente): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "cliente": cliente
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/Update", data, { headers: this.headers }).pipe(
      catchError((err) => {
        if (err.status === 400 && err.error && err.error.erros) {
          this.toastr.error(err.error.erros.join(', '), 'Campos obrigatórios (Efetivo):');
        } else {
          this.toastr.error("", "Houve um erro, contate o suporte...");
        }
        return of(false);
      })
    );
  }

  public updateCadastroEfetivadoById(client_id_app: number, efetivar: boolean): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app,
      "efetivar": efetivar
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/UpdateCadastroEfetivadoById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public updateContatoById(client_id_app: number, contato: string, email_02: string, observacao: string, telefone_2: string, telefone_3: string, ddd_whatsApp: string, telefone_whatsApp: string, inside_sales_ativo: boolean): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app,
      "contato": contato,
      "email_02": email_02,
      "observacao": observacao,
      "telefone_2": telefone_2,
      "telefone_3": telefone_3,
      "ddd_whatsApp": ddd_whatsApp,
      "telefone_whatsApp": telefone_whatsApp,
      "inside_sales_ativo": inside_sales_ativo
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/UpdateContatoById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public updateUltimaVisitaById(client_id_app: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/UpdateUltimaVisitaById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public updateGeolocalizacaoAntigaById(client_id_app: number) {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/updateGeolocalizacaoAntigaById", data, {
      headers: this.headers.set('X-Objetivos-Token', localStorage.getItem('dashboard_objetivos_token') || '')
    }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public updateGeolocalizacaoById(client_id: number, oficial_gps_lat: number, oficial_gps_lon: number, precisao: string): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id": client_id,
      "oficial_gps_lat": oficial_gps_lat,
      "oficial_gps_lon": oficial_gps_lon,
      "precisao": precisao
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/UpdateGeolocalizacaoById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public updateIsActiveById(client_id_app: number, is_active: boolean): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app,
      "is_active": is_active
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/UpdateIsActiveById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public reintegrarCliente(id: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/ReintegrarCliente", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public updateCodigoErpById(client_id_app: number, codigo: string): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app,
      "codigo": codigo
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/UpdateCodigoErpById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public updatePasswordById(client_id_app: number, liberar: boolean, password_b2b: string): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app,
      "liberar": liberar,
      "password_b2b": password_b2b
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/UpdatePasswordById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public updatePasswordInicialById(client_id_app: number, liberar: boolean): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app,
      "liberar": liberar
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/UpdatePasswordInicialById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public updateWhatsAppById(client_id_app: number, fone_whatss_ddd: string, fone_whatss: string): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app,
      "fone_whatss_ddd": fone_whatss_ddd,
      "fone_whatss": fone_whatss,
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/UpdateWhatsAppById", data, { headers: this.headers, reportProgress: true }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public validarCNPJ(client_document: string): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_document": client_document
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/ValidarCNPJ", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public consultarCNPJHub(client_document: string): Observable<Cliente> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_document": client_document
    };

    return this.http.post<Cliente>(this.baseUrl + "api/Cliente/ConsultarCNPJHub", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(null);
      })
    );
  }

  /* Cliente (Arquivo) */

  public addClienteArquivo(arquivo: File, cliente_arquivo: ClienteArquivo): Observable<boolean> {
    this.headers.append("Content-Type", "multipart/form-data");

    let formData = new FormData();

    formData.append("arquivo", arquivo, arquivo.name);
    formData.set("client_id_app", cliente_arquivo.client_id_app.toString());
    formData.set("descricao", cliente_arquivo.descricao);

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/AddClienteArquivo", formData, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public deleteClienteArquivo(id: string, nm_arquivo: string): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id,
      "nm_arquivo": nm_arquivo
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/DeleteClienteArquivo", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public getClienteArquivoByCliente(client_id_app: number): Observable<ClienteArquivo[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app
    };

    return this.http.post<ClienteArquivo[]>(this.baseUrl + "api/Cliente/GetClienteArquivoByCliente", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Cliente (Vinculos entre Clientes) */

  public getClientesVinculados(clientIdPrincipal: number, exibirLoader: boolean = true): Observable<ClienteVinculado[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis"),
      "client_id_principal": clientIdPrincipal
    };

    return this.http.post<ClienteVinculado[]>(this.baseUrl + "api/ClienteVinculo/GetClientesVinculados", data, { headers: exibirLoader ? this.headers : this.headers.set("X-Skip-Loader", "true") }).pipe(
      catchError(() => {
        return of([]);
      })
    );
  }

  public vincularCliente(clientIdPrincipal: number, clientIdVinculado: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis"),
      "client_id_principal": clientIdPrincipal,
      "client_id_vinculado": clientIdVinculado
    };

    return this.http.post<boolean>(this.baseUrl + "api/ClienteVinculo/VincularCliente", data, { headers: this.headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        this.toastr.error("", (error.error && error.error.message) || "Houve um erro ao vincular o cliente.");

        return of(false);
      })
    );
  }

  public desvincularCliente(vinculoId: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "vinculo_id": vinculoId
    };

    return this.http.post<boolean>(this.baseUrl + "api/ClienteVinculo/DesvincularCliente", data, { headers: this.headers }).pipe(
      catchError((error: HttpErrorResponse) => {
        this.toastr.error("", (error.error && error.error.message) || "Houve um erro ao remover o vínculo.");

        return of(false);
      })
    );
  }

  /* Cliente (Contato Call Center) */

  public getContatoCallCenterById(id: number, exibirLoader: boolean = true): Observable<string> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id
    };

    return this.http.post<string>(this.baseUrl + "api/Cliente/GetContatoCallCenterById", data, { headers: exibirLoader ? this.headers : this.headers.set("X-Skip-Loader", "true") }).pipe(
      catchError(() => {
        return of(null);
      })
    );
  }

  public updateContatoCallCenterById(id: number, contato: string): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id,
      "contato": contato
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/UpdateContatoCallCenterById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro ao salvar o contato.");

        return of(false);
      })
    );
  }

  /* Cliente (Observação Geral) */

  public getObservacaoGeralById(id: number, exibirLoader: boolean = true): Observable<string> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id
    };

    return this.http.post<string>(this.baseUrl + "api/Cliente/GetObservacaoGeralById", data, { headers: exibirLoader ? this.headers : this.headers.set("X-Skip-Loader", "true") }).pipe(
      catchError(() => {
        return of(null);
      })
    );
  }

  public updateObservacaoGeralById(id: number, observacao: string): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id,
      "observacao": observacao
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/UpdateObservacaoGeralById", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro ao salvar a observação.");

        return of(false);
      })
    );
  }

  /* Cliente (Local Entrega) */

  public getClienteLocalEntregaByCliente(id: number): Observable<ClienteLocalEntrega[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id
    };

    return this.http.post<ClienteLocalEntrega[]>(this.baseUrl + "api/Cliente/GetClienteLocalEntregaByCliente", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Cliente (Tabela) */

  public getTabelaByIdCliente(client_id_app: number): Observable<ClienteTabela[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app
    };

    return this.http.post<ClienteTabela[]>(this.baseUrl + "api/Cliente/GetTabelaByIdCliente", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Cliente (Tag) */

  public addTag(client_id_app: number, tags: string[]): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "client_id_app": client_id_app,
      "tags": tags
    };

    return this.http.post<boolean>(this.baseUrl + "api/Cliente/AddTag", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }
}
